<template>
  <div class="odds-mgmt"
       v-if="oddsMgmtEditModeData">
    <div class="filter-search-box flex-center">
      <FilterBox class="filter"
                 :fb-filters="oddsMgmtEditModeData.filters"
                 :fb-types="oddsMgmtEditModeData.filterTypes"
                 :fb-active-filters="oddsMgmtEditModeData.activeFilters"
                 :fb-translations="oddsMgmtEditModeData.filterDisplayName"/>
      <IconSearchBox class="icon-search"></IconSearchBox>
    </div>
    <ContentBox class="content"
                :content-data="oddsMgmtEditModeData.data"
                :content-titles="oddsMgmtEditModeData.titles"
                :content-sums="oddsMgmtEditModeData.sums"
                :content-columns="oddsMgmtEditModeData.columns"
                :content-pagination="oddsMgmtEditModeData.pagination"
                :content-type="'main'"
                :style="{width: '100%'}"/>
    <div class="action-buttons">
      <AdminButton :ab-value="'general_cancel'"
                   :ab-name="'cancel'"
                   :ab-style-name="'default filter'"/>
      <AdminButton v-on:admin-button="saveOddsMgmt"
                   :ab-value="'general_save'"
                   :ab-name="'save'"
                   :ab-disabled="notificationMessage
                   && notificationMessage.description === 'admin_maxOddValidationMessage'"
                   :ab-style-name="'primary filter rules'"/>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import EventBus from '@/store/EventBus';
import ContentBox from '@/components/ContentBox';
import FilterBox from '@/components/FilterBox';
import IconSearchBox from '@/components/IconSearchBox';
import AdminButton from '@/components/AdminButton';
import { updateEdit } from '@/api';
import createHeaders from '@/api/utility';

export default {
  name: 'OddsMgmt',
  components: {
    AdminButton,
    IconSearchBox,
    FilterBox,
    ContentBox,
  },
  computed: {
    ...mapGetters([
      'oddsMgmtEditModeData',
      'notificationMessage',
      'discoverServerLocation',
      'user',
      'editActive',
    ]),
  },
  methods: {
    ...mapActions([
      'setNotificationMessage',
      'setEditModeData',
      'fetchEditModules',
      'updateEditModeData',
      'setActiveLoader',
    ]),
    saveOddsMgmt() {
      this.setActiveLoader(true);
      const url = `${this.discoverServerLocation.productApi.url}/client/odds`;
      const headers = createHeaders(this.discoverServerLocation, this.user);
      const data = {
        tournamentId: this.editActive.selectionData.id,
        data: this.oddsMgmtEditModeData.data,
        userId: this.user.uuid,
      };
      updateEdit(url, data, headers)
        .then(() => {
          this.setNotificationMessage({
            title: 'general_success',
            description: 'admin_changesSavedSuccessfully',
            rulesActions: false,
          });
          this.setActiveLoader(false);
        })
        .catch((e) => {
          this.setNotificationMessage({
            title: 'general_error',
            description: e.response.data.message || 'error',
            rulesActions: false,
          });
          this.setActiveLoader(false);
        });
    },
  },
  mounted() {
    EventBus.$on('odds-updated', (data) => {
      this.updateEditModeData({
        prop: 'data',
        data,
      });
    });
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === 'edit') {
      this.$router.go(-1);
    }
    next(true);
  },
};
</script>

<style lang="scss" scoped>
  .odds-mgmt {
    height: calc(100% - 50px);
    padding-bottom: 56px;
    position: relative;
    .filter-search-box {
      .filter {
        width: 75%;
      }
      .icon-search {
        background-color: #e8ecee;
        height: 50px;
        width: 25%;
      }
    }
    .content {
      padding-bottom: 56px;
    }
    .action-buttons {
      align-items: center;
      background-color: #e8ecee;
      bottom: 0;
      display: flex;
      height: 56px;
      justify-content: flex-end;
      padding-right: 15px;
      position: absolute;
      right: 0;
      width: 100%;
      &:first-child {
        margin-right: 10px;
      }
    }
  }
</style>
